import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  const requiredPermission = route.data['permission'] as string | undefined;
  const requiredRole = route.data['role'] as string | undefined;

  if (requiredPermission && !authService.hasPermission(requiredPermission)) {
    return router.createUrlTree(['/dashboard']);
  }

  if (requiredRole && !authService.hasRole(requiredRole)) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
